// Дата окончания действия SSL сертификата в uxin формате
const lastSSLDay = "1694168868";

export const countSSL = () =>
    ((lastSSLDay - (new Date().getTime() / 1000).toFixed()) / 86400).toFixed();

// https://www.unixtimestamp.com
